import { createContext, useContext } from "react";

export const BoundContext = createContext<
  React.MutableRefObject<HTMLDivElement>
>({} as any);

export const useBoundContext = () => useContext(BoundContext);
